module.exports = __webpack_public_path__ + "img/icon21.a5fa3903.png";